<template lang="pug">
  .expertise-included.xs-12
    .xs-12.md-6.lg-6.md-pr-100m
      SectionTitle(:text="title").text-center

      .top-wrap.text-center
        p.expertise-text.xs-f-small.lg-f-medium.max-at-tweak {{text}}

    .xs-12.md-6.lg-6
      ContactCtasSection

</template>

<script>
  import SectionTitle from "../SectionTitle";
  import ContactCtasSection from '@components/ContactCtasSection';

  export default {
    name: 'ExpertiseIncluded',

    components: {
      SectionTitle,
      ContactCtasSection,
    },

    props: {

      title: {
        type: String,
        default: 'Expertise Included',
      },

      text: {
        type: String,
        default: 'Any questions? Our licensed professional colorists are here to help.',
      },
    },
  };
</script>

<style scoped lang="stylus">
  .expertise-included
    overflow hidden

    .top-wrap
      padding 1.5em 0
      max-width 25em
      margin auto

    .ctas-section
      display flex
      flex-direction column

    @media mq-desktop
      .top-wrap
        margin auto
        max-width 22em

</style>
